import React from "react";

import { dynamicFilterFilter } from "app/filters/dynamicFilter";

import { UpgradeLink } from "./UpgradeLink";

export class ItemImageCell extends React.Component<any, any> {
    private dynamicFilter: any;

    constructor(props: FixmeType) {
        super(props);
        this.dynamicFilter = dynamicFilterFilter();
    }

    render() {
        const { value, row, tableOptions, tableMetadata, format = "None" } = this.props;
        const template = (
            <div>
                <img
                    src={row.Icon || row.Favicon}
                    className="favicon icon-text-margin"
                />
                {this.dynamicFilter(value, format)}
            </div>
        );
        const upgradeTemplate = <UpgradeLink />;
        return value === "grid.upgrade" ? upgradeTemplate : template;
    }
}
